export default __webpack_public_path__ + "static/king-9a6c3334977c32ad72110f7f333972c6.png";